var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Accordion, List, Link, Text, Divider, Stack, Container, } from "@bookingcom/bui-react";
import "../TravellerFooter.types";
var MobileFooterList = function (_a) {
    var lists = _a.lists;
    return (React.createElement(Container, { attributes: { "data-testid": "mobile-footer-lists" } },
        React.createElement(Stack, { gap: 3 }, lists.map(function (list) { return (React.createElement(React.Fragment, { key: list.title },
            React.createElement(Accordion, { attributes: list.attributes, titleContent: React.createElement(Text, { tagName: "h3", variant: "emphasized_2" }, list.title) },
                React.createElement(List, { items: list.items.map(function (item) { return ({
                        content: (React.createElement(Link, __assign({ key: item.href, variant: "secondary" }, item))),
                    }); }) })),
            React.createElement(Divider, null))); }))));
};
export default MobileFooterList;
